module.exports = __webpack_public_path__ + "img/mobile-contact-qd.c84731b3.webp";